import Main from "./components/Main";
import Tecnologias from "./components/Tecnologias";
import Projetos from "./components/Projetos";
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <Main />
      <Tecnologias />
      <Projetos />
      <Footer />
    </div>
  );
}

export default App;
